import { useEffect } from "react";
import {
  ActionIcon,
  Group,
  rem,
  Stack,
  Tabs,
  Text,
} from "@mantine/core";
import {
  IconChevronLeft,
  IconPhoto,
  IconVideo,
} from "@tabler/icons-react";
import { ErrorBoundary } from "@sentry/react";
import Fallback from "../_Common/Fallback";
import { useStore } from "../store";
import { getPlugins } from "../api";
import GeneratorOptions from "./GeneratorOptions";
import GeneratorOptionsVideo from "./GeneratorOptionsVideo";

const iconStyle = { width: rem(16), height: rem(16) };

export default function GenerateRail({ onCollapse }) {
  const setPluginData = useStore((state) => state.setPluginData);

  // pluginData persists in localStorage; re-sync it so the per-tab video/image
  // plugin filtering reflects the manifests currently installed server-side.
  useEffect(() => {
    getPlugins().then(setPluginData).catch(() => {});
  }, [setPluginData]);

  return (
    <Stack gap={0} h="100%">
      <Group justify="space-between" wrap="nowrap" px="xs" pt="xs">
        <Text fz="xs" fw={600} tt="uppercase" c="dimmed">
          Generate
        </Text>
        <ActionIcon
          variant="subtle"
          size="sm"
          title="Collapse generator"
          onClick={onCollapse}
        >
          <IconChevronLeft size={16} stroke={1.5} />
        </ActionIcon>
      </Group>
      <Tabs defaultValue="image" keepMounted={false}>
        <Tabs.List grow px="xs">
          <Tabs.Tab
            value="image"
            leftSection={<IconPhoto style={iconStyle} stroke={1.5} />}
          >
            Image
          </Tabs.Tab>
          <Tabs.Tab
            value="video"
            leftSection={<IconVideo style={iconStyle} stroke={1.5} />}
          >
            Video
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="image">
          <ErrorBoundary fallback={Fallback}>
            <GeneratorOptions />
          </ErrorBoundary>
        </Tabs.Panel>
        <Tabs.Panel value="video">
          <ErrorBoundary fallback={Fallback}>
            <GeneratorOptionsVideo />
          </ErrorBoundary>
        </Tabs.Panel>
      </Tabs>
    </Stack>
  );
}
